export default {
  'menu.third-platform.wechat': 'WeChat',
  'menu.third-platform.wechat.public-accounts': 'Official Accounts',
  'menu.third-platform.wechat.mini-programs': 'Mini Programs',
  'menu.third-platform.fei-shu.apps': 'Applications',
  'menu.third-platform.work-wx.group-chat': 'Customer Groups',

  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.data': 'Data Platform',
  'menu.data.customer-management': 'Customer Management',
  'menu.data.customer-management.customer-list': 'Customer List',
  'menu.data.customer-management.customer-stage': 'Customer Stages',
  'menu.data.customer-management.customer-field': 'Customer Fields',
  'menu.data.customer-management.customer-source': 'Customer Sources',
  'menu.data.customer-management.customer-channel': 'Customer Channels',
  'menu.system.project-management': 'Project Management',
  'menu.system.project-management.project-list': 'Project List',
  'menu.data.automation-workflow': 'Automation Workflow',
  'menu.data.automation-workflow.workflow-list': 'Workflow List',
  'menu.data.automation-workflow.workflow-config': 'Configure Workflow',
  'menu.sale.sale-order.order-center': 'Order Center',
  'menu.frontend': 'Sales Platform',
  'menu.backend': 'Service Platform',
  'menu.frontend.experience-camp-users': 'Level 1 User Details',
  'menu.frontend.auto-ops': 'Automation Ops',
  'menu.frontend.auto-ops.hosted-wx': 'Hosted WeChat Accounts',
  'menu.frontend.auto-ops.juzi-account': 'JuZi Accounts',
  'menu.frontend.auto-ops.sop-template': 'Community SOP Templates',
  'menu.frontend.auto-ops.sop-template-edit': 'Edit Template',
  'menu.frontend.auto-ops.sop-template-edit-id': 'Edit Template',
  'menu.frontend.auto-ops.task': 'Tasks',
  'menu.frontend.auto-ops.task-create': 'Create Task',
  'menu.frontend.auto-ops.task-detail': 'Task Detail',
  'menu.system.course-period': 'Camp Period Management',
  'menu.third-platform.qianchuan': 'Qianchuan',
  'menu.third-platform.wechat-pay': 'WeChat Pay',
  'menu.third-platform.wechat-pay.wechat-pay-merchant-account':
    'Merchant Accounts',
  'menu.third-platform.wechat-pay.wechat-pay-fund-flow': 'Fund Flow',
  'menu.third-platform.wechat-pay.wechat-pay-trade-bill': 'Trade Bill',
  'menu.third-platform.qianchuan.app': 'Applications',
  'menu.third-platform.qianchuan.authorization': 'Authorizations',
  'menu.third-platform.qianchuan.authorized-account': 'Authorized Subjects',
  'menu.third-platform.qianchuan.account': 'Ad Accounts',
  'menu.third-platform.qianchuan.account-report': 'Report Details',
  'menu.third-platform.qianchuan.report-summary': 'Report Summary',
  'menu.third-platform.qianchuan.material-report': 'Material Report',
  'menu.system': 'System Settings',
  'menu.system.course': 'Training Camp Management',
  'menu.system.product': 'Product Management',
  'menu.system.channel': 'Channel Management',
  'menu.system.team': 'Team Management',
  'menu.system.team.member': 'Member Management',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.system.application-center': 'Application Center',
  'menu.system.application-center.wechat-public-accounts':
    'WeChat Official Accounts',
  'menu.system.application-center.wechat-mini-programs': 'WeChat Mini Programs',
  'menu.system.application-center.work-wx-apps': 'WeCom',
  'menu.system.application-center.fei-shu-apps': 'Feishu',
};
